<template>
  <div class="checkout-form business-form-rps"  v-if="showRpsFields">
    <zm-form-item
      :label="__$t('billing.export_control.biz_org_type')"
      size="xLarge"
      class="bpm-addr__required text-capitalize-form-item"
      ref="businessType"
      prop="businessType"
      for="business-type"
      aria-label="required"
    >
    <zm-select filterable v-model="form.businessType"
      :label="__$t('billing.export_control.biz_org_type')">
        <zm-option
          v-for="item in bizTypes"
          :key="item"
          :label="__$t('billing.export_control.' + item)"
          :value="item"
        ></zm-option>
      </zm-select>
    </zm-form-item>
    <zm-form-item
      :label="__$t('billing.export_control.input_placeholder')"
      size="xLarge"
      ref="otherBusinessType"
      prop="otherBusinessType"
      for="biz-type-other"
      class="bpm-addr__required text-capitalize-form-item"
      aria-label="required"
      v-if="form.businessType === 'other' "
    >
      <zm-input v-model="form.otherBusinessType"  id="biz-type-other"/>
    </zm-form-item>
  </div>
</template>

<script>
import formMixins from './mixins/form-mixin.js';
import { bizTypes } from '../../common/constant';
import { APP_NAMESPACE } from '../../store';
import { mapGetters } from "vuex";
export default {
  name: 'businessFormRps',
  mixins: [formMixins],
  props: {
    form: {
      type: Object,
    },
  },
  data() {
    return {
      bizTypes: bizTypes,
    };
  },
  methods: {
    mx_isHighRiskCountries(countryCode) {
      const e2openHighRiskCountries  =  this.billingInfoConfig?.e2open?.e2openHighRiskCountries || [];
      return countryCode && e2openHighRiskCountries.includes(countryCode);
    },
  },
  computed: {
    ...mapGetters(APP_NAMESPACE, [
      'billingInfoConfig'
    ]),
    showRpsFields(){
      return this.mx_isHighRiskCountries(this.form.country) || this.mx_isHighRiskCountries(this.form.accountHq)
    }
  },
};
</script>
<style lang="scss">
.business-form-rps{
  margin-bottom: 12px;
}
</style>
